import React from "react";
import { motion } from "framer-motion";
import { CheckCircle, MessageSquareText, ThumbsUp, TrendingUp } from "lucide-react";

const steps = [
  {
    icon: <MessageSquareText className="w-8 h-8 text-purple-600" />,
    title: "Step 1: Engage Clients",
    desc: "Clients scan a QR code or get a message right after their appointment to share feedback instantly.",
  },
  {
    icon: <CheckCircle className="w-8 h-8 text-purple-600" />,
    title: "Step 2: Collect Insights",
    desc: "Zola gathers structured data and reviews from clients in real-time, organized by staff or service.",
  },
  {
    icon: <ThumbsUp className="w-8 h-8 text-purple-600" />,
    title: "Step 3: Boost Reviews",
    desc: "Happy clients are nudged to leave glowing reviews on Google, Facebook, or Instagram.",
  },
  {
    icon: <TrendingUp className="w-8 h-8 text-purple-600" />,
    title: "Step 4: Track Growth",
    desc: "Access a full dashboard to track performance, repeat clients, and team impact — all in one place.",
  },
];

const HowItWorksBeauty = () => {
  return (
    <section className="w-full bg-purple-50 py-20">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <motion.h2
          initial={{ opacity: 0, y: -10 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-3xl md:text-4xl font-bold text-gray-900 mb-6"
        >
          How <span className="text-purple-600">Zola</span> Works for Salons
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="text-lg text-gray-600 mb-14 max-w-2xl mx-auto"
        >
          Zola makes it easy to engage clients, gather feedback, and grow your beauty brand — in just a few simple steps.
        </motion.p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {steps.map((step, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: idx * 0.2 }}
              className="bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition"
            >
              <div className="mb-4 flex justify-center">{step.icon}</div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">
                {step.title}
              </h3>
              <p className="text-sm text-gray-600">{step.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksBeauty;
